import { StateService } from "@core-services/state.service";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { PortfolioAssetDetails, PortfolioOverview } from "@modules/portfolio/domain/entities/portfolio-overview.model";
import { map } from "rxjs/operators";

export interface PortfolioOverviewState extends PortfolioOverview {
	error: boolean;
	isLoading: boolean;
}

@Injectable({
	providedIn: "root"
})
export class PortfolioOverviewStateService extends StateService<PortfolioOverviewState> {
	public portfolios$: Observable<PortfolioAssetDetails[]> = this.getState$().pipe(
		map((state) => {
			return state?.portfolios;
		})
	);

	public constructor() {
		super(null);
	}

	public getState$(): Observable<PortfolioOverviewState> {
		return this.select((state) => state);
	}

	public updateState(model: PortfolioOverviewState): void {
		this.setState(model);
	}

	public overviewErrorState(): void {
		this.updateState({
			asset_group_total_returns: [],
			portfolios: [],
			error: true,
			isLoading: false
		});
	}

	public hasError(): boolean {
		return this.state?.error;
	}

	public isOverviewLoaded(): boolean {
		return this.isStateLoaded();
	}

	public setIsLoading(isLoading: boolean): void {
		this.setState({
			isLoading: isLoading
		});
	}
}
